import fetch from './api';
export const getRecord = (type) => {
  return fetch.get(`/record/${type}`);
}

export const postRecord = (data) => {
  return fetch.post('/record/', data)
}
